import React from 'react';
import _ from 'lodash';
import BzmIcon from '../../icons/BzmIcon';

type NoResponsePlaceholderProps = {
  height: number;
  placeHolderContent: string | any;
  iconSize?: string;
};

const NoContentPlaceholder = (props: NoResponsePlaceholderProps) => {
  const iconSize = props.iconSize ? props.iconSize : '48px';
  return (
    <div style={{ height: props.height }}>
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
        <div className="text-center">
          <BzmIcon variant={'icon-bzm-info'} className={'text-muted icon-xlg'} style={{ fontSize: iconSize }} />
          {_.isString(props.placeHolderContent) ? (
            <p className="mt-2">{props.placeHolderContent}</p>
          ) : (
            <div className={'mt-2'}>{props.placeHolderContent}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoContentPlaceholder;
